import '../ChangeRequestComment/comments.scss';

import { arrayOf } from 'prop-types';
import React from 'react';

import {
  getProductLabel,
  transformCampaignLine,
} from '../../campaign-editor/transform-for-rendering';
import withProducts from '../../products/withProducts/with-products';
import { changeRequestShape, productShape } from '../../prop-types';
import NewDraftCampaignLine from './NewDraftCampaignLine';

function AddProductComment(props) {
  const { changeRequest, products } = props;
  const newLines = changeRequest.draftCampaignLines.map(line =>
    transformCampaignLine(line, products),
  );
  const primaryLine = newLines[0];
  const newProduct = primaryLine.product;

  return (
    <>
      <h5 className="my-3 text-success">Add {getProductLabel(newProduct)}</h5>
      <div
        className={`c-comment__campaignline_wrapper mb-2 cards-${
          newLines.length > 1 && newLines.length % 2 ? 'odd' : 'even'
        }`}
      >
        {newLines.map(line => (
          <NewDraftCampaignLine key={line.id} line={line} />
        ))}
      </div>
    </>
  );
}

AddProductComment.propTypes = {
  changeRequest: changeRequestShape.isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
};

export default withProducts({})(AddProductComment);
